import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const aud = (n) => `A$${Number(n || 0).toFixed(Number(n) % 1 ? 2 : 0)}`;
const firstSentence = (t = '') => (t.match(/^.*?[.!?](\s|$)/) || [t])[0].trim();

const TownStrip = ({ guides, dark }) => (
  <div className="flex flex-wrap gap-3" data-testid="pack-feature-towns">
    {(guides || []).map((g) => (
      <Link key={g.product_id} to={`/shop/guides/${g.slug}`} className={`flex items-center gap-2 pr-3 rounded-full border transition-colors ${dark ? 'border-white/15 hover:border-[#C5A059] text-[#FAF7F2]/85' : 'border-[#E6DAC5] hover:border-[#C5A059] text-[#1E1622]/80 bg-white'}`}>
        <img src={g.cover_image_url} alt={g.town} className="w-9 h-9 rounded-full object-cover" />
        <span className="text-sm">{g.town}</span>
      </Link>
    ))}
  </div>
);

const PackPanel = ({ p, eyebrow, line, testId }) => (
  <div className="grid lg:grid-cols-5 gap-0 rounded-3xl overflow-hidden bg-[#2D1037]" data-testid={testId}>
    <div className="lg:col-span-2 relative min-h-[360px]">
      <img src={p.cover_image_url || p.guides?.[0]?.cover_image_url} alt={p.name} data-testid={`${testId}-cover`} className="absolute inset-0 w-full h-full object-contain p-6 bg-[#3B164C]" />
    </div>
    <div className="lg:col-span-3 p-8 md:p-12 text-[#FAF7F2]">
      <span className="eyebrow mb-4 text-[#C5A059]"><span className="w-10 h-px bg-[#C5A059]" /> {eyebrow}</span>
      <h2 className="font-display text-3xl md:text-4xl font-medium mb-2" data-testid={`${testId}-name`}>{p.name}</h2>
      <p className="text-sm uppercase tracking-[0.2em] text-[#E5C178] mb-5">{p.region} · {p.guide_count} town guides{p.includes_toolkit ? ' + offline toolkits' : ''}</p>
      {line && <p className="text-[#FAF7F2]/70 font-light leading-relaxed mb-6 max-w-xl">{line}</p>}
      <div className="mb-8"><TownStrip guides={p.guides} dark /></div>
      <div className="flex flex-wrap items-center gap-6">
        <p className="font-display text-2xl" data-testid={`${testId}-price`}>
          {aud(p.price_aud)}{p.savings_aud > 0 && <span className="text-base text-[#E5C178]"> · save {aud(p.savings_aud)}</span>}
        </p>
        <Link to={`/shop/packs/${p.slug}`} data-testid={`${testId}-cta`} className="btn-gold inline-flex items-center gap-2">View the collection <ArrowRight size={18} /></Link>
      </div>
    </div>
  </div>
);

export const RegionPackFeature = ({ p }) => (
  <div className="mb-14"><PackPanel p={p} eyebrow="Get every town in one pack" line={p.description} testId="region-pack" /></div>
);

export const PackOfTheMonth = () => {
  const [pack, setPack] = useState(null);
  useEffect(() => { axios.get(`${API}/featured-pack`).then((r) => setPack(r.data.pack || null)).catch(() => setPack(null)); }, []);
  if (!pack) return null;
  return (
    <section className="pt-20 md:pt-28 bg-[#FAF7F2]" data-testid="pack-of-the-month">
      <div className="container-custom">
        <PackPanel p={pack} eyebrow="Pack of the month" line={firstSentence(pack.region_intro || pack.description)} testId="potm" />
      </div>
    </section>
  );
};
